import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-771f20ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "activity-inviteCode" }
const _hoisted_4 = { class: "activity-inviteCode-use" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "activity-inviteCode-content" }
const _hoisted_7 = { class: "activity-inviteCode-desc" }
const _hoisted_8 = { class: "activity-inviteCode-wrapper" }
const _hoisted_9 = { class: "activity-tips" }
const _hoisted_10 = { class: "guide" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "remark" }
const _hoisted_13 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_t_button = _resolveComponent("t-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["banner", { eng: _ctx.isEng }])
    }, [
      _createElementVNode("img", {
        src: _ctx.configInfo['banner-m2'],
        alt: ""
      }, null, 8, _hoisted_2)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["activity", { eng: _ctx.isEng }])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: _ctx.configInfo['inviteCodePic-m2'],
            alt: ""
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.configInfo['inviteCodeinfo-m2']), 1),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.inviteCode), 1)
        ])
      ]),
      _createElementVNode("p", _hoisted_9, [
        _createTextVNode(_toDisplayString(_ctx.configInfo['inviteCodeContract-m2']) + " ", 1),
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.checkProto && _ctx.checkProto(...args)))
        }, _toDisplayString(_ctx.$t('本条款及细则')), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('约束。请细阅有关条款及细则。')), 1)
      ]),
      _createVNode(_component_t_button, {
        "data-clipboard-text": _ctx.inviteCode,
        class: "activity-copy",
        theme: "primary",
        text: _ctx.$t('复制邀请码'),
        onClick: _ctx.handleClick
      }, null, 8, ["data-clipboard-text", "text", "onClick"])
    ], 2),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("img", {
        src: _ctx.configInfo['guide-m2'],
        alt: ""
      }, null, 8, _hoisted_11)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("img", {
        src: _ctx.configInfo['remark-m2'],
        alt: ""
      }, null, 8, _hoisted_13)
    ])
  ]))
}